import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { DollarSign } from 'lucide-react';
export function Refund() {
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-668">
      <Header data-id="element-669" />
      <main className="flex-grow" data-id="element-670">
        <section className="py-20 bg-gradient-to-br from-[#0D7377] to-[#14919B] text-white" data-id="element-671">
          <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-672">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white bg-opacity-20 rounded-full mb-6" data-id="element-673">
              <DollarSign size={32} data-id="element-674" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-675">
              Refund Policy
            </h1>
            <p className="text-xl text-gray-100" data-id="element-676">
              Transparent refund terms for our repair services
            </p>
          </div>
        </section>
        <section className="py-16 bg-white" data-id="element-677">
          <div className="max-w-4xl mx-auto px-4" data-id="element-678">
            <div className="prose prose-lg max-w-none" data-id="element-679">
              <div className="bg-gray-50 p-6 rounded-xl mb-8" data-id="element-680">
                <p className="text-sm text-gray-600" data-id="element-681">
                  <strong data-id="element-682">Contact:</strong> info@caringhand.it.com | 0800 055
                  4969
                </p>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-683">
                Our Refund Promise
              </h2>
              <p className="text-gray-700 leading-relaxed mb-6" data-id="element-684">
                At Caringhand, we are committed to providing excellent service
                and transparent pricing. If you are not satisfied with your
                booking or need to request a refund, we have clear policies in
                place to ensure fairness for all parties.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-685">
                Refund Timeframes
              </h2>
              <div className="space-y-6 mb-8" data-id="element-686">
                <div className="bg-green-50 border-l-4 border-green-500 p-6 rounded-r-xl" data-id="element-687">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-688">
                    0-14 Days: Full Refund Available
                  </h3>
                  <p className="text-gray-700" data-id="element-689">
                    Request a full refund within 14 days of your booking date if
                    no repair work has been completed. If diagnostics or repairs
                    have already been carried out, the refund will be adjusted
                    accordingly to reflect the work completed.
                  </p>
                </div>
                <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 rounded-r-xl" data-id="element-690">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-691">
                    15-28 Days: Partial Refund Possible
                  </h3>
                  <p className="text-gray-700" data-id="element-692">
                    Between 15 and 28 days, partial refunds may be granted at
                    our discretion based on the work completed and costs
                    incurred. We will assess each request individually and
                    communicate the refund amount clearly.
                  </p>
                </div>
                <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-r-xl" data-id="element-693">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-694">
                    After 28 Days: No Refunds
                  </h3>
                  <p className="text-gray-700" data-id="element-695">
                    After 28 days from the booking date, refunds are not
                    available. This policy ensures we can maintain competitive
                    pricing and service quality for all customers.
                  </p>
                </div>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-696">
                How to Request a Refund
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-697">
                To request a refund, please follow these steps:
              </p>
              <ol className="list-decimal pl-6 mb-6 text-gray-700 space-y-2" data-id="element-698">
                <li data-id="element-699">
                  Contact us by email at info@caringhand.it.com or phone 0800
                  055 4969
                </li>
                <li data-id="element-700">
                  Provide your booking reference number and contact details
                </li>
                <li data-id="element-701">Explain the reason for your refund request</li>
                <li data-id="element-702">
                  We will review your request and respond within 2 working days
                </li>
                <li data-id="element-703">
                  If approved, refunds are processed to your original payment
                  method within 5-10 working days
                </li>
              </ol>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-704">
                Payment Processing
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-705">
                All payments are securely processed through Stripe, our trusted
                payment partner. Refunds are issued to the same payment method
                used for the original transaction. Please allow 5-10 working
                days for the funds to appear in your account, depending on your
                bank or card issuer.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-706">
                When Refunds Are Not Available
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-707">
                Refunds may not be granted in the following circumstances:
              </p>
              <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2" data-id="element-708">
                <li data-id="element-709">After 28 days from the booking date</li>
                <li data-id="element-710">
                  When diagnostics or repairs have been successfully completed
                </li>
                <li data-id="element-711">For pre-existing faults not caused by our service</li>
                <li data-id="element-712">
                  When appliance damage is due to misuse or third-party work
                </li>
                <li data-id="element-713">For commercial or non-domestic appliance use</li>
                <li data-id="element-714">When the appliance is beyond economical repair</li>
              </ul>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-715">
                Disputes & Chargebacks
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-716">
                Before initiating a chargeback or payment dispute with your
                bank, please contact us directly. We are committed to resolving
                any concerns fairly and quickly. Chargebacks can delay
                resolution and may affect your ability to use our services in
                the future.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-717">
                Your Consumer Rights
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-718">
                This refund policy does not affect your statutory rights under
                UK consumer law. If you believe your rights have been affected,
                please contact us to discuss your concerns, or seek advice from
                Citizens Advice or your local Trading Standards office.
              </p>
              <div className="bg-[#0D7377] bg-opacity-10 p-6 rounded-xl mt-8" data-id="element-719">
                <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-720">
                  Questions About Refunds?
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-721">
                  If you have any questions about our refund policy or need
                  assistance with a refund request, please contact us:
                </p>
                <div className="space-y-2" data-id="element-722">
                  <p className="text-gray-700" data-id="element-723">
                    <strong data-id="element-724">Email:</strong> info@caringhand.it.com
                  </p>
                  <p className="text-gray-700" data-id="element-725">
                    <strong data-id="element-726">Phone:</strong> 0800 055 4969
                  </p>
                  <p className="text-gray-700" data-id="element-727">
                    <strong data-id="element-728">Address:</strong> 157 Ashley Rd, Hale, Altrincham
                    WA15 9SD
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-729" />
    </div>;
}